/**
 * Match Constants
 * Shared constants for match-related components
 */

export const VENUES = ['home', 'away', 'neutral'];
export const STATUSES = ['upcoming', 'result', 'postponed', 'abandoned'];

// Match formats with player count
export const MATCH_FORMATS = [
  { value: '11v11', label: '11 v 11', players: 11, defaultBenchSlots: 7 },
  { value: '9v9', label: '9 v 9', players: 9, defaultBenchSlots: 5 },
  { value: '7v7', label: '7 v 7', players: 7, defaultBenchSlots: 5 },
  { value: '5v5', label: '5 v 5', players: 5, defaultBenchSlots: 3 },
  { value: '3v3', label: '3 v 3', players: 3, defaultBenchSlots: 2 },
];

// Formations organized by format
export const FORMATIONS_BY_FORMAT = {
  '11v11': ['4-4-2', '4-3-3', '4-2-3-1', '3-5-2', '3-4-3', '5-3-2', '5-4-1', '4-5-1', '4-1-4-1', '3-2-3-2', '2-3-2-3'],
  '9v9': ['3-3-2', '3-2-3', '2-4-2', '3-4-1', '2-3-3', '4-3-1'],
  '7v7': ['2-3-1', '3-2-1', '2-2-2', '1-3-2', '3-1-2', '2-1-3'],
  '5v5': ['2-1-1', '1-2-1', '2-2', '1-1-2', '1-3'],
  '3v3': ['1-1', '2-0', '0-2'],
};

// Legacy export for backwards compatibility
export const FORMATIONS = FORMATIONS_BY_FORMAT['11v11'];

export const EVENT_TYPES = [
  { value: 'goal', label: 'Goal', icon: '⚽' },
  { value: 'penalty_goal', label: 'Penalty', icon: '⚽' },
  { value: 'own_goal', label: 'Own Goal', icon: '⚽' },
  { value: 'missed_penalty', label: 'Missed Penalty', icon: '❌' },
  { value: 'assist', label: 'Assist', icon: '👟' },
  { value: 'yellow_card', label: 'Yellow Card', icon: '🟨' },
  { value: 'red_card', label: 'Red Card', icon: '🟥' },
  { value: 'substitution_in', label: 'Substitution In', icon: '🔼' },
  { value: 'substitution_out', label: 'Substitution Out', icon: '🔽' },
  { value: 'pen_scored', label: 'Penalty Scored', icon: '✅' },
  { value: 'pen_missed', label: 'Penalty Missed', icon: '❌' }
];

// 11v11 Formations
export const FORMATION_POSITIONS = {
  // 11v11 Formations
  '4-4-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 15, y: 70, label: 'LB' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'RB', x: 85, y: 70, label: 'RB' },
    { id: 'LM', x: 15, y: 45, label: 'LM' },
    { id: 'CM1', x: 38, y: 50, label: 'CM' },
    { id: 'CM2', x: 62, y: 50, label: 'CM' },
    { id: 'RM', x: 85, y: 45, label: 'RM' },
    { id: 'ST1', x: 35, y: 20, label: 'ST' },
    { id: 'ST2', x: 65, y: 20, label: 'ST' },
  ],
  '4-3-3': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 15, y: 70, label: 'LB' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'RB', x: 85, y: 70, label: 'RB' },
    { id: 'CM1', x: 30, y: 48, label: 'CM' },
    { id: 'CM2', x: 50, y: 58, label: 'CDM' },
    { id: 'CM3', x: 70, y: 48, label: 'CM' },
    { id: 'LW', x: 15, y: 22, label: 'LW' },
    { id: 'ST', x: 50, y: 15, label: 'ST' },
    { id: 'RW', x: 85, y: 22, label: 'RW' },
  ],
  '4-2-3-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 15, y: 70, label: 'LB' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'RB', x: 85, y: 70, label: 'RB' },
    { id: 'DM1', x: 38, y: 55, label: 'DM' },
    { id: 'DM2', x: 62, y: 55, label: 'DM' },
    { id: 'LM', x: 20, y: 35, label: 'LM' },
    { id: 'AM', x: 50, y: 32, label: 'AM' },
    { id: 'RM', x: 80, y: 35, label: 'RM' },
    { id: 'ST', x: 50, y: 12, label: 'ST' },
  ],
  '3-5-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 25, y: 70, label: 'CB' },
    { id: 'CB2', x: 50, y: 73, label: 'CB' },
    { id: 'CB3', x: 75, y: 70, label: 'CB' },
    { id: 'LWB', x: 12, y: 32, label: 'LWB' },
    { id: 'CDM1', x: 35, y: 55, label: 'CDM' },
    { id: 'CDM2', x: 65, y: 55, label: 'CDM' },
    { id: 'AM', x: 50, y: 38, label: 'AM' },
    { id: 'RWB', x: 88, y: 32, label: 'RWB' },
    { id: 'ST1', x: 38, y: 20, label: 'ST' },
    { id: 'ST2', x: 62, y: 20, label: 'ST' },
  ],
  '3-4-3': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 25, y: 75, label: 'CB' },
    { id: 'CB2', x: 50, y: 78, label: 'CB' },
    { id: 'CB3', x: 75, y: 75, label: 'CB' },
    { id: 'LM', x: 15, y: 50, label: 'LM' },
    { id: 'CM1', x: 38, y: 50, label: 'CM' },
    { id: 'CM2', x: 62, y: 50, label: 'CM' },
    { id: 'RM', x: 85, y: 50, label: 'RM' },
    { id: 'LW', x: 20, y: 20, label: 'LW' },
    { id: 'ST', x: 50, y: 15, label: 'ST' },
    { id: 'RW', x: 80, y: 20, label: 'RW' },
  ],
  '5-3-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LWB', x: 10, y: 65, label: 'LWB' },
    { id: 'CB1', x: 30, y: 75, label: 'CB' },
    { id: 'CB2', x: 50, y: 78, label: 'CB' },
    { id: 'CB3', x: 70, y: 75, label: 'CB' },
    { id: 'RWB', x: 90, y: 65, label: 'RWB' },
    { id: 'CM1', x: 30, y: 48, label: 'CM' },
    { id: 'CM2', x: 50, y: 45, label: 'CM' },
    { id: 'CM3', x: 70, y: 48, label: 'CM' },
    { id: 'ST1', x: 35, y: 18, label: 'ST' },
    { id: 'ST2', x: 65, y: 18, label: 'ST' },
  ],
  '5-4-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LWB', x: 10, y: 65, label: 'LWB' },
    { id: 'CB1', x: 30, y: 75, label: 'CB' },
    { id: 'CB2', x: 50, y: 78, label: 'CB' },
    { id: 'CB3', x: 70, y: 75, label: 'CB' },
    { id: 'RWB', x: 90, y: 65, label: 'RWB' },
    { id: 'LM', x: 15, y: 45, label: 'LM' },
    { id: 'CM1', x: 38, y: 48, label: 'CM' },
    { id: 'CM2', x: 62, y: 48, label: 'CM' },
    { id: 'RM', x: 85, y: 45, label: 'RM' },
    { id: 'ST', x: 50, y: 15, label: 'ST' },
  ],
  '4-5-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 15, y: 70, label: 'LB' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'RB', x: 85, y: 70, label: 'RB' },
    { id: 'LM', x: 10, y: 45, label: 'LM' },
    { id: 'CM1', x: 30, y: 48, label: 'CM' },
    { id: 'CM2', x: 50, y: 42, label: 'CM' },
    { id: 'CM3', x: 70, y: 48, label: 'CM' },
    { id: 'RM', x: 90, y: 45, label: 'RM' },
    { id: 'ST', x: 50, y: 15, label: 'ST' },
  ],
  '4-1-4-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 15, y: 70, label: 'LB' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'RB', x: 85, y: 70, label: 'RB' },
    { id: 'DM', x: 50, y: 58, label: 'DM' },
    { id: 'LM', x: 15, y: 40, label: 'LM' },
    { id: 'CM1', x: 38, y: 38, label: 'CM' },
    { id: 'CM2', x: 62, y: 38, label: 'CM' },
    { id: 'RM', x: 85, y: 40, label: 'RM' },
    { id: 'ST', x: 50, y: 15, label: 'ST' },
  ],
  '3-2-3-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 25, y: 75, label: 'CB' },
    { id: 'CB2', x: 50, y: 78, label: 'CB' },
    { id: 'CB3', x: 75, y: 75, label: 'CB' },
    { id: 'CM1', x: 35, y: 60, label: 'CM' },
    { id: 'CM2', x: 65, y: 60, label: 'CM' },
    { id: 'LM', x: 15, y: 40, label: 'LM' },
    { id: 'AM', x: 50, y: 38, label: 'AM' },
    { id: 'RM', x: 85, y: 40, label: 'RM' },
    { id: 'ST1', x: 35, y: 18, label: 'ST' },
    { id: 'ST2', x: 65, y: 18, label: 'ST' },
  ],
  '2-3-2-3': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'LM', x: 15, y: 58, label: 'LM' },
    { id: 'CM', x: 50, y: 60, label: 'CM' },
    { id: 'RM', x: 85, y: 58, label: 'RM' },
    { id: 'LW', x: 20, y: 38, label: 'LW' },
    { id: 'RW', x: 80, y: 38, label: 'RW' },
    { id: 'LF', x: 20, y: 18, label: 'LF' },
    { id: 'ST', x: 50, y: 15, label: 'ST' },
    { id: 'RF', x: 80, y: 18, label: 'RF' },
  ],
  
  // 9v9 Formations
  '3-3-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 20, y: 72, label: 'LB' },
    { id: 'CB', x: 50, y: 75, label: 'CB' },
    { id: 'RB', x: 80, y: 72, label: 'RB' },
    { id: 'LM', x: 20, y: 48, label: 'LM' },
    { id: 'CM', x: 50, y: 50, label: 'CM' },
    { id: 'RM', x: 80, y: 48, label: 'RM' },
    { id: 'ST1', x: 35, y: 20, label: 'ST' },
    { id: 'ST2', x: 65, y: 20, label: 'ST' },
  ],
  '3-2-3': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 20, y: 72, label: 'LB' },
    { id: 'CB', x: 50, y: 75, label: 'CB' },
    { id: 'RB', x: 80, y: 72, label: 'RB' },
    { id: 'CM1', x: 35, y: 50, label: 'CM' },
    { id: 'CM2', x: 65, y: 50, label: 'CM' },
    { id: 'LW', x: 20, y: 22, label: 'LW' },
    { id: 'ST', x: 50, y: 18, label: 'ST' },
    { id: 'RW', x: 80, y: 22, label: 'RW' },
  ],
  '2-4-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'LM', x: 15, y: 48, label: 'LM' },
    { id: 'CM1', x: 38, y: 50, label: 'CM' },
    { id: 'CM2', x: 62, y: 50, label: 'CM' },
    { id: 'RM', x: 85, y: 48, label: 'RM' },
    { id: 'ST1', x: 35, y: 20, label: 'ST' },
    { id: 'ST2', x: 65, y: 20, label: 'ST' },
  ],
  '3-4-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 20, y: 72, label: 'LB' },
    { id: 'CB', x: 50, y: 75, label: 'CB' },
    { id: 'RB', x: 80, y: 72, label: 'RB' },
    { id: 'LM', x: 15, y: 48, label: 'LM' },
    { id: 'CM1', x: 38, y: 50, label: 'CM' },
    { id: 'CM2', x: 62, y: 50, label: 'CM' },
    { id: 'RM', x: 85, y: 48, label: 'RM' },
    { id: 'ST', x: 50, y: 18, label: 'ST' },
  ],
  '2-3-3': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 75, label: 'CB' },
    { id: 'CB2', x: 65, y: 75, label: 'CB' },
    { id: 'LM', x: 20, y: 50, label: 'LM' },
    { id: 'CM', x: 50, y: 52, label: 'CM' },
    { id: 'RM', x: 80, y: 50, label: 'RM' },
    { id: 'LW', x: 20, y: 22, label: 'LW' },
    { id: 'ST', x: 50, y: 18, label: 'ST' },
    { id: 'RW', x: 80, y: 22, label: 'RW' },
  ],
  '4-3-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 15, y: 70, label: 'LB' },
    { id: 'CB1', x: 38, y: 75, label: 'CB' },
    { id: 'CB2', x: 62, y: 75, label: 'CB' },
    { id: 'RB', x: 85, y: 70, label: 'RB' },
    { id: 'LM', x: 25, y: 48, label: 'LM' },
    { id: 'CM', x: 50, y: 50, label: 'CM' },
    { id: 'RM', x: 75, y: 48, label: 'RM' },
    { id: 'ST', x: 50, y: 18, label: 'ST' },
  ],
  
  // 7v7 Formations
  '2-3-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 72, label: 'CB' },
    { id: 'CB2', x: 65, y: 72, label: 'CB' },
    { id: 'LM', x: 20, y: 48, label: 'LM' },
    { id: 'CM', x: 50, y: 50, label: 'CM' },
    { id: 'RM', x: 80, y: 48, label: 'RM' },
    { id: 'ST', x: 50, y: 20, label: 'ST' },
  ],
  '3-2-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 20, y: 72, label: 'LB' },
    { id: 'CB', x: 50, y: 75, label: 'CB' },
    { id: 'RB', x: 80, y: 72, label: 'RB' },
    { id: 'CM1', x: 35, y: 48, label: 'CM' },
    { id: 'CM2', x: 65, y: 48, label: 'CM' },
    { id: 'ST', x: 50, y: 20, label: 'ST' },
  ],
  '2-2-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 72, label: 'CB' },
    { id: 'CB2', x: 65, y: 72, label: 'CB' },
    { id: 'CM1', x: 35, y: 48, label: 'CM' },
    { id: 'CM2', x: 65, y: 48, label: 'CM' },
    { id: 'ST1', x: 35, y: 22, label: 'ST' },
    { id: 'ST2', x: 65, y: 22, label: 'ST' },
  ],
  '1-3-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB', x: 50, y: 72, label: 'CB' },
    { id: 'LM', x: 20, y: 48, label: 'LM' },
    { id: 'CM', x: 50, y: 50, label: 'CM' },
    { id: 'RM', x: 80, y: 48, label: 'RM' },
    { id: 'ST1', x: 35, y: 22, label: 'ST' },
    { id: 'ST2', x: 65, y: 22, label: 'ST' },
  ],
  '3-1-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'LB', x: 20, y: 72, label: 'LB' },
    { id: 'CB', x: 50, y: 75, label: 'CB' },
    { id: 'RB', x: 80, y: 72, label: 'RB' },
    { id: 'CM', x: 50, y: 48, label: 'CM' },
    { id: 'ST1', x: 35, y: 22, label: 'ST' },
    { id: 'ST2', x: 65, y: 22, label: 'ST' },
  ],
  '2-1-3': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 72, label: 'CB' },
    { id: 'CB2', x: 65, y: 72, label: 'CB' },
    { id: 'CM', x: 50, y: 50, label: 'CM' },
    { id: 'LW', x: 20, y: 25, label: 'LW' },
    { id: 'ST', x: 50, y: 20, label: 'ST' },
    { id: 'RW', x: 80, y: 25, label: 'RW' },
  ],
  
  // 5v5 Formations
  '2-1-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 70, label: 'CB' },
    { id: 'CB2', x: 65, y: 70, label: 'CB' },
    { id: 'CM', x: 50, y: 48, label: 'CM' },
    { id: 'ST', x: 50, y: 22, label: 'ST' },
  ],
  '1-2-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB', x: 50, y: 70, label: 'CB' },
    { id: 'CM1', x: 30, y: 48, label: 'CM' },
    { id: 'CM2', x: 70, y: 48, label: 'CM' },
    { id: 'ST', x: 50, y: 22, label: 'ST' },
  ],
  '2-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 68, label: 'CB' },
    { id: 'CB2', x: 65, y: 68, label: 'CB' },
    { id: 'ST1', x: 35, y: 28, label: 'ST' },
    { id: 'ST2', x: 65, y: 28, label: 'ST' },
  ],
  '1-1-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB', x: 50, y: 70, label: 'CB' },
    { id: 'CM', x: 50, y: 48, label: 'CM' },
    { id: 'ST1', x: 35, y: 22, label: 'ST' },
    { id: 'ST2', x: 65, y: 22, label: 'ST' },
  ],
  '1-3': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB', x: 50, y: 68, label: 'CB' },
    { id: 'LW', x: 25, y: 30, label: 'LW' },
    { id: 'ST', x: 50, y: 22, label: 'ST' },
    { id: 'RW', x: 75, y: 30, label: 'RW' },
  ],
  
  // 3v3 Formations
  '1-1': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB', x: 50, y: 60, label: 'CB' },
    { id: 'ST', x: 50, y: 28, label: 'ST' },
  ],
  '2-0': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'CB1', x: 35, y: 55, label: 'CB' },
    { id: 'CB2', x: 65, y: 55, label: 'CB' },
  ],
  '0-2': [
    { id: 'GK', x: 50, y: 90, label: 'GK' },
    { id: 'ST1', x: 35, y: 35, label: 'ST' },
    { id: 'ST2', x: 65, y: 35, label: 'ST' },
  ],
};
